module.exports = __webpack_public_path__ + "static/media/image (35).5bfe2ecf.jpg";